import { render } from "./AddressCard.vue?vue&type=template&id=d0bbf1a6&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"

import "./AddressCard.vue?vue&type=style&index=0&id=d0bbf1a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bbf1a6"]])

export default __exports__